__turbopack_context__.v({
  "desktop-only": "Footer-module-scss-module__EMknuq__desktop-only",
  "footer-accordion": "Footer-module-scss-module__EMknuq__footer-accordion",
  "footer-bottom": "Footer-module-scss-module__EMknuq__footer-bottom",
  "footer-bottom-nav": "Footer-module-scss-module__EMknuq__footer-bottom-nav",
  "footer-legal": "Footer-module-scss-module__EMknuq__footer-legal",
  "footer-logo": "Footer-module-scss-module__EMknuq__footer-logo",
  "footer-logo-container": "Footer-module-scss-module__EMknuq__footer-logo-container",
  "footer-mainnav": "Footer-module-scss-module__EMknuq__footer-mainnav",
  "footer-mainnav-column": "Footer-module-scss-module__EMknuq__footer-mainnav-column",
  "footer-middle": "Footer-module-scss-module__EMknuq__footer-middle",
  "footer-middle-inner": "Footer-module-scss-module__EMknuq__footer-middle-inner",
  "footer-newsletter": "Footer-module-scss-module__EMknuq__footer-newsletter",
  "footer-shopnav": "Footer-module-scss-module__EMknuq__footer-shopnav",
  "footer-shopnav-section": "Footer-module-scss-module__EMknuq__footer-shopnav-section",
  "footer-shopnav-super": "Footer-module-scss-module__EMknuq__footer-shopnav-super",
  "footer-shopnav-title": "Footer-module-scss-module__EMknuq__footer-shopnav-title",
  "footer-social": "Footer-module-scss-module__EMknuq__footer-social",
  "footer-text": "Footer-module-scss-module__EMknuq__footer-text",
  "footer-top": "Footer-module-scss-module__EMknuq__footer-top",
  "mobile-only": "Footer-module-scss-module__EMknuq__mobile-only",
  "social-icons": "Footer-module-scss-module__EMknuq__social-icons",
  "social-image": "Footer-module-scss-module__EMknuq__social-image",
});
